import AddTermsConditions from "../terms-and-conditions/AddTermsConditions";

export default function AddCompanyTermsConditions() {
  return (
    <AddTermsConditions
      tcType="company"
      listPath="/company-terms-and-conditions"
    />
  );
}
